import type { SiteTheme } from "~/theme/types";

export const homeTheme: SiteTheme = {
  slug: "home",
  tokens: {
    primary: "#111",
    primarySoft: "rgba(0,0,0,0.06)",
    primaryHover: "#000",
    primaryGlow: "0,0,0",
    bg: "#ffffff",
    surface: "#f0f0f0",
    text: "#111",
    textBody: "#666",
    textMuted: "#999",
  },
};
